// extracted by mini-css-extract-plugin
module.exports = {"destacatMapaAnimat":"destacatMapaAnimat_destacatMapaAnimat__8jndQ","titol":"destacatMapaAnimat_titol__8XnCe","imatgeWrapper":"destacatMapaAnimat_imatgeWrapper__dDmWw"};